module.exports = __webpack_public_path__ + "static/media/DSC_0875.bb2cb98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0875.jpg
// module id = 610
// module chunks = 0